import type { ReactNode } from 'react';

import Layout from '@/ui/components/layout';
import Navbar from '@/ui/components/navbar';
import { cn } from '@/ui/utils/classnames.js';
import FixedHeader from './parts/fixed-header.js';
import ResponsiveHeader from './parts/responsive-header.js';

export type BasePageProps = {
  children: ReactNode;
  noNavbar?: boolean;
  className?: string;
  scrollContainerClassName?: string;
};

export type ResponsivePageProps = {
  title?: string;
  responsiveLayout: true;
};

export type FixedPageProps = {
  title?: never;
  responsiveLayout?: false;
};

export type PageProps = BasePageProps & (ResponsivePageProps | FixedPageProps);

function Page({
  children,
  title,
  noNavbar = false,
  responsiveLayout,
  className,
  scrollContainerClassName,
}: PageProps) {
  return (
    <div className="flex size-full">
      {!noNavbar && <Navbar />}

      <Layout
        // Arbitrary value padding to accommodate navbar on small view widths.
        className={cn(responsiveLayout && 'pb-[120px] md:pb-10', className)}
        scrollContainerClassName={scrollContainerClassName}
        header={
          responsiveLayout ? (
            <ResponsiveHeader title={title!} />
          ) : (
            <FixedHeader />
          )
        }
        responsive={responsiveLayout}
      >
        {children}
      </Layout>
    </div>
  );
}

export default Page;
